import { FC } from "react";
import {
  urlDetector,
  YOUTUBE,
  VIMEO,
  BRIGHTCOVE,
  ZOOM,
  EMPTY,
} from "../utils/urlDetector";
import VimeoPlayer from "./vimeo-player";
import YoutubePlayer from "./youtube-player";
import NotSupported from "./not-supported";
import FringePlayer from "./fringe-player";
import ZoomPlayer from "./zoom-player";
import EmptyPlayer from "./empty-player";

interface IPlayer {
  contentUrl: string;
}

const Player: FC<IPlayer> = ({ contentUrl }) => {
  const loadPlayer = () => {
    switch (urlDetector(contentUrl)) {
      case YOUTUBE: {
        return <YoutubePlayer contentUrl={contentUrl} />;
      }
      case VIMEO: {
        return <VimeoPlayer contentUrl={contentUrl} />;
      }
      case BRIGHTCOVE: {
        return <FringePlayer contentUrl={contentUrl} />;
      }
      case ZOOM: {
        return <ZoomPlayer contentUrl={contentUrl} />;
      }
      case EMPTY: {
        return <EmptyPlayer />;
      }
      default:
        return <NotSupported contentUrl={contentUrl}/>;
    }
  };

  return loadPlayer();
};

export default Player;
